export enum CommonsStrings {
  ERROR_AUTHENTICATION_TITLE = '¡OOPS! 401!',
  ERROR_AUTHENTICATION_BODY = 'Valida tu usuario o contraseña para que puedas iniciar sesión.',
  ERROR_GENERIC_BODY = 'Tenemos un error ',
  ERROR_GENERIC_TITLE = '¡OOPS! Error!',
  LOADER_TEXT = 'Cargando Datos',
  CANCEL = 'Cancel',
  ACCEPT = 'Aceptar',
  SLASH = '/',
  MIME_TYPE_PNG = 'image/png',
  MIME_TYPE_MP3 = 'audio/mpeg',
  MIME_TYPE_JPEG = 'image/jpeg',
  MIME_TYPE_JPG = 'image/jpg',
  MIME_TYPE_VIDEO = 'video/mp4',
  REGEX_VERSION = '^[1-9]\\d*(\\.[1-9]\\d*)*$',
  EMPTY_STRING = '',
  HEADER_SEPOMEX_API = 'header_sepomex_api',
  HEADER_SEPOMEX_URL = 'sepomex_url',
  MONKEY_API = 'aki-key-qr',
}

export enum CommonsUI {
  BUTTON_MIN_W = 60,
  BUTTON_MIN_H = 40,
  IMAGE_MIN_W = 200,
  IMAGE_MIN_H = 100,
  BUTTON_IMAGE_MIN_W = 120,
  BUTTON_IMAGE_MIN_H = 50,
  CAROUSEL_MIN_W = 300,
  CAROUSEL_MIN_H = 250,
  ZERO = 0,
  VIDEO_W = 350,
  VIDEO_H = 280,
}
